// ─────────────────────────────────────────────────────────────
// src/pages/TaxCalculator/components/ResultsCard.jsx
// Displays tax-calculation results for individual mode.
// Pure UI – receives computed results as props.
// ─────────────────────────────────────────────────────────────

import React from "react";
import { DollarSign, CheckCircle } from "lucide-react";

const ResultsCard = ({ results, styles, t, theme, currentTheme, isRTL }) => {
  const totalDeductions = results.empShare + results.monthlyTax + results.martyrsFund;

  return (
    <div style={styles.card}>
      <h2
        style={{
          fontSize:     "26px",
          fontWeight:   "800",
          color:        currentTheme.colors.textPrimary,
          marginBottom: "24px",
          textAlign:    isRTL ? "right" : "center",
        }}
      >
        {t.calculationResults}
      </h2>

      {/* Summary metric cards */}
      <div style={styles.resultsGrid}>
        <div style={styles.resultCard("#2e7cba")}>
          <div style={styles.resultLabel}>{t.grossSalary}</div>
          <div style={styles.resultValue("#2e7cba")}>
            <DollarSign size={28} />
            {results.grossSalary.toFixed(2)} {t.egp}
          </div>
        </div>

        <div style={styles.resultCard("#10b981")}>
          <div style={styles.resultLabel}>{t.netSalary}</div>
          <div style={styles.resultValue("#10b981")}>
            <DollarSign size={28} />
            {results.netSalary.toFixed(2)} {t.egp}
          </div>
        </div>

        <div style={styles.resultCard("#f59e0b")}>
          <div style={styles.resultLabel}>{t.monthlyTax}</div>
          <div style={styles.resultValue("#f59e0b")}>
            {results.monthlyTax.toFixed(2)} {t.egp}
          </div>
        </div>

        <div style={styles.resultCard("#8b5cf6")}>
          <div style={styles.resultLabel}>{t.martyrsFund}</div>
          <div style={styles.resultValue("#8b5cf6")}>
            {results.martyrsFund.toFixed(3)} {t.egp}
          </div>
        </div>
      </div>

      {/* Deduction breakdown */}
      <div style={styles.summaryCard}>
        <div style={styles.summaryTitle}>
          <CheckCircle size={20} />
          {t.deductionDetails}
        </div>

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>{t.employeeInsuranceShare}</span>
          <span style={styles.summaryValue}>{results.empShare.toFixed(2)} {t.egp}</span>
        </div>

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>{t.monthlyIncomeTax}</span>
          <span style={styles.summaryValue}>{results.monthlyTax.toFixed(2)} {t.egp}</span>
        </div>

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>{t.yearlyTax}</span>
          <span style={styles.summaryValue}>{results.yearlyTax.toFixed(2)} {t.egp}</span>
        </div>

        {/* Total */}
        <div
          style={{
            ...styles.summaryRow,
            borderBottom: "none",
            marginTop:    "12px",
            paddingTop:   "16px",
            borderTop:    `2px solid ${currentTheme.colors.border}`,
          }}
        >
          <span style={{ ...styles.summaryLabel, fontWeight: "700", fontSize: "16px" }}>
            {t.totalDeductions}
          </span>
          <span style={{ ...styles.summaryValue, fontSize: "18px", color: "#ef4444" }}>
            {totalDeductions.toFixed(2)} {t.egp}
          </span>
        </div>
      </div>

      {/* Disclaimer note */}
      <div
        style={{
          marginTop:    "24px",
          padding:      "16px",
          borderRadius: "12px",
          background:   theme === "dark"
            ? "rgba(59,130,246,0.1)"
            : "rgba(59,130,246,0.05)",
          border:     "1px solid rgba(59,130,246,0.2)",
          fontSize:   "14px",
          color:      currentTheme.colors.textSecondary,
          lineHeight: "1.6",
          textAlign:  isRTL ? "right" : "left",
          direction:  isRTL ? "rtl" : "ltr",
        }}
      >
        <strong>{t.note}:</strong> {t.noteText}
      </div>
    </div>
  );
};

export default ResultsCard;